import { LoanCriteria } from '@nemuru-eng/js-api-client';

import { useCustomTheme } from '../../../../../../hooks/useCustomTheme';
import { SizedIconWithCircle } from '../../../../../shared/components/SizedIconWithCircle';
import { Text } from '../../../../../shared/components/Text';
import { getIconByAssetOrArticleType } from '../../getIconByAssetOrArticleType';

export const assetTypeFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette, customBorderRadius } = useCustomTheme();
  return {
    flex: flex ?? 0.15,
    disableOnRowClick: true,
    field: 'asset_type',
    sortable: false,
    headerName: <Text tId={'TYPE'} />,
    renderCell: (rowData: { row: LoanCriteria }) => {
      return (
        <SizedIconWithCircle
          variant={'medium'}
          backgroundColor={palette.grey[50]}
          iconColor={palette.grey[500]}
          customBorderRadius={customBorderRadius.chip}
          iconName={getIconByAssetOrArticleType(rowData.row.assetType, rowData.row.onboardingType)}
          copyToClipboard={{ value: rowData.row.id, textId: 'COPY_LOAN_ID' }}
        />
      );
    },
  };
};
